import { useEffect } from 'react';

const QRCodeModal = ({
    qrUrl,
    route,
    text,
    onClose
}) => {

    const zoomRaw = getComputedStyle(document.documentElement).getPropertyValue('--zoom');
    const zoom = parseFloat(zoomRaw); // strips '%' if present
    const scale = 100 / zoom; // 50% zoom => scale = 2, 150% zoom => scale ≈ 0.666
    const qrSize = 260 * scale; 

    // Automatically close after 20 seconds
    useEffect(() => {
        const timer = setTimeout(onClose, 20000); // 20 seconds
        return () => clearTimeout(timer);
    }, [onClose]);

    
    // Inject mappedin minimap script and config
    useEffect(() => {
        // Set mappedin config
        window.mappedin = {
            clientId: "68e8fd605f9eb023b7e20706",
            clientSecret: "Bb8l04KVl38DKZBtS2GnlVgFQk0od05aSJr3vcqFSpQrNkMQ",
            venue: "redding-downtown-terminal",
            locationId: route, // Dynamic location ID based on prop
            fullMapUrl: "https://web.mappedin.com/redding-area-bus-authority/redding-downtown-terminal.html#/",
        };

        // Inject script
        const script = document.createElement('script');
        script.src = "https://cdn.mappedin.com/minimap/release/minimap.js?venue=redding-downtown-terminal";
        script.type = "text/javascript";
        script.async = true;
        document.getElementById('mappedin-minimap')?.appendChild(script);

        return () => {
            // Clean up: remove script and mappedin config
            document.getElementById('mappedin-minimap')?.removeChild(script);
            delete window.mappedin;
        };
    }, [route]);

    return (
        <div className="QRCodeModal" onClick={onClose}>
            <div className="QRCodeModal__content" onClick={e => e.stopPropagation()}>
                <p style={{ fontSize: `${qrSize / 14}px` }}>Scan the QR code with your phone for walking directions</p>
                <p
                    style={{
                        fontSize: `${qrSize / 14}px`,
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '0.3em',
                        margin: '0.5em 0'
                    }}
                >
                    <span>to the</span>
                    {
                        text
                        ? <span className="QRCodeModal__bold">{text}</span>
                        : <span>appropriate</span>
                    }
                    <span>gate</span>
                </p>
                <div className="QRCodeModal_iframe_container" >
                     <iframe
                        title="Mappedin Minimap"
                        className="QRCodeModal__img"
                        src={qrUrl}
                        // style={{ width: `90%`, height: `100%`, border: 'none', zoom: 80 / zoom }}
                    />
                </div>
                <button className="QRCodeModal__close" onClick={onClose}> Close </button>
            </div>
        </div>
    );
}

export default QRCodeModal;
